export default __webpack_public_path__ + "images/0892135f41be68e512322597f7f99f89.png";